import { AxiosResponse } from 'axios';
import { API } from '../providers/ApiInterceptorProvider';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchEligibilityByRefNumber = (id: string): Promise<AxiosResponse<any>> =>
  API.get(`/legacy-underwriter/eligibilityChecks?applicationRefNo=${id}`);
